import React from "react";
import im1 from "../../assets/WhyJoin/Analyze.png";
import im2 from "../../assets/WhyJoin/Experts.png";
import im3 from "../../assets/WhyJoin/la_medal.png";
import im4 from "../../assets/WhyJoin/person.png";
import "./WhyChoose.css";
// import SectionHeading from "../shared/SectionHeading";

const WhyChoose = () => {
  return (
    <div className="bg-white flex relative flex-col max-sm:mt-8  max-w-[1380px] mx-auto">
      <div className="parent bg-white space-y-4 ">
        {/* div1 */}
        <div className="div1 relative lg:text-right text-left flex justify-end gap-1 lg:gap-10 items-center w-full">
          <div className="text-base font-normal text-secondary2 space-y-3 w-[60%] lg:w-[70%]">
            <h1 className="text-[19px] font-normal text-transparent bg-clip-text bg-gradient-to-r from-primary-color to-secondary-color">
              Unmatched Mentorship
            </h1>
            <p className="text-[16px] max-sm:text-[13 px] text-16 font-normal text-base">
              An invaluable resource for individuals looking to ace their
              interviews and land their dream jobs.
            </p>
          </div>
          <div className="h-32 w-32 border justify-self-end overflow-hidden relative rounded-tl-[100px] rounded-tr-[100px] rounded-br-none rounded-bl-[100px]">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-color to-secondary-color"></div>
            <div className="absolute inset-[2px] bg-white rounded-tl-[100px] rounded-tr-[100px] rounded-br-none rounded-bl-[100px] flex justify-center items-center">
              <div className="h-12 w-12 rounded-full overflow-hidden shadow-custom">
                <img className="" src={im1} alt="" />
              </div>
            </div>
          </div>
        </div>

        {/* div2 */}
        <div className="div2 flex justify-start gap-1 lg:gap-10 items-center">
          <div className="h-32 w-32 border overflow-hidden relative rounded-tl-[100px] rounded-tr-[100px] rounded-br-[100px] rounded-bl-none">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-color to-secondary-color"></div> {/* updated */}
            <div className="absolute inset-[2px] bg-white rounded-tl-[100px] rounded-tr-[100px] rounded-br-[100px] rounded-bl-none flex justify-center items-center">
              <div className="h-12 w-12 rounded-full overflow-hidden shadow-custom">
                <img className="h-10 w-10 mx-auto" src={im2} alt="" />
              </div>
            </div>
          </div>
          <div className="text-black text-right lg:text-left space-y-3 w-[60%] lg:w-[70%]">
            <h1 className="text-[19px] font-normal text-transparent bg-clip-text bg-gradient-to-r from-primary-color to-secondary-color">
              University Partnership
            </h1>
            <p className="text-[16px] max-sm:text-[13 px] text-16 font-normal text-base">
              Our partnerships with top universities ensure that you receive
              quality education and recognized certifications
            </p>
          </div>
        </div>

        {/* div3 */}
        <div className="div3 flex justify-end gap-1 lg:gap-10 items-center">
          <div className="text-black lg:text-right text-left space-y-3 w-[60%] lg:w-[70%]">
            <h1 className="text-[19px] font-normal text-transparent bg-clip-text bg-gradient-to-r from-primary-color to-secondary-color">
              Wide Range of Courses
            </h1>
            <p className="text-[16px] max-sm:text-[13 px] text-16 font-normal text-base">
              Choose from a variety of courses in different domains to enhance
              your knowledge and skills
            </p>
          </div>
          <div className="h-32 w-32 border overflow-hidden relative rounded-tl-[100px] rounded-tr-[100px] rounded-br-none rounded-bl-[100px]">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-color to-secondary-color"></div>
            <div className="absolute inset-[2px] bg-white rounded-tl-[100px] rounded-tr-[100px] rounded-br-none rounded-bl-[100px] flex justify-center items-center">
              <div className="h-12 w-12 rounded-full overflow-hidden shadow-custom">
                <img className="object-cover" src={im3} alt="" />
              </div>
            </div>
          </div>
        </div>

        {/* div4 */}
        <div className="div4 flex justify-between lg:justify-start gap-1 lg:gap-10 items-center">
          <div className="h-32 w-32 border overflow-hidden relative rounded-tl-[100px] rounded-tr-[100px] rounded-br-[100px] rounded-bl-none">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-color to-secondary-color"></div>
            <div className="absolute inset-[2px] bg-white rounded-tl-[100px] rounded-tr-[100px] rounded-br-[100px] rounded-bl-none flex justify-center items-center">
              <div className="h-12 w-12 rounded-full overflow-hidden shadow-custom">
                <img className="h-10 w-10 mx-auto align-middle my-auto" src={im4} alt="" />
              </div>
            </div>
          </div>
          <div className="text-black text-right lg:text-left space-y-3 w-[60%] lg:w-[70%]">
            <h1 className="text-[19px] font-normal text-transparent bg-clip-text bg-gradient-to-r from-primary-color to-secondary-color">
              Direct Interview Scheduling
            </h1>
            <p className="text-[16px] max-sm:text-[13 px] text-16 font-normal text-base">
              By using direct interview scheduling, employers can save time and
              effort by automating the process of finding available time slots,
              sending out invitations, and managing responses.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
